<template>
  <ol :class="`${themeColor}`">
    <li
      :class="['chapter-list', item.current ? 'current' : '']"
      v-for="(item, index) in contentList"
      :key="item.name + '-' + item.id + '-' + index"
      :index="item.name + '-' + item.id + '-' + index"
    >
      <div class="collapse-icon" @click="handleCollapse(item.id)">
        <span>{{ item.name }}</span>
        <i
          :class="
            !openIds.includes(item.id)
              ? 'el-icon-arrow-down'
              : 'el-icon-arrow-up'
          "
        ></i>
      </div>
      <ul v-if="item.children && openIds.includes(item.id)">
        <li
          :class="['section-list', isCurrent(subItem.id) ? 'current' : '']"
          v-for="subItem in item.children"
          :key="subItem.name + '-' + subItem.id"
          :index="subItem.name + '-' + subItem.id"
        >
          <div
            @click="handleClick(subItem)"
            :id="subItem.name + '-' + subItem.id"
          >
            <em v-if="subItem.icon" :class="subItem.icon"></em>
            {{ subItem.name }}
          </div>
        </li>
      </ul>
    </li>
  </ol>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    contentList: {
      type: [Array, Object],
      required: true
    },
    from: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      openIds: []
    };
  },
  watch: {
    $route(val) {
      const { openIds } = this;
      const { id } = this.$route.params;
      if (!openIds.includes(id)) {
        openIds.push(id);
      }
    }
  },
  created() {
    this.openIds.push(Number(this.$route.params.chapterId));
  },
  computed: {
    isCurrent() {
      return function(id) {
        return this.$route.params.sectionId == id;
      };
    },
    themeColor() {
      return this.$store.getters.theme;
    }
  },
  methods: {
    handleCollapse(id) {
      const { openIds } = this;
      if (openIds.includes(id)) {
        openIds.splice(openIds.indexOf(id), 1);
      } else openIds.push(id);
    },
    handleClick(item) {
      this.$router.replace({
        name: item.routeName,
        params: item.params,
        query: this.$route.query || { from: this.from }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dark {
  .chapter-list {
    color: #ffffff;
    li.section-list {
      color: #ffffff;
    }
  }
}
.light {
  .chapter-list {
    color: #333;
    li.section-list {
      color: #333;
    }
  }
}
.chapter-list {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 20px;
  list-style-type: none;
  cursor: default;
  ul {
    padding-left: 15px;
  }
  li.section-list {
    list-style-type: none;
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    cursor: pointer;
  }
  .collapse-icon {
    span {
      max-width: 190px;
    }
    position: relative;
    padding-right: 20px;
    cursor: pointer;
    i {
      font-size: 10px;
      position: absolute;
      right: 8px;
      font-weight: 900;
      top: 8px;
    }
  }
}
ol {
  padding-left: 20px;
  margin-top: 0px;
}
.disabled {
  // pointer-events: none;
  opacity: 0.6;
}
.active {
  // pointer-events: auto;
  opacity: 0.6;
}
.current {
  color: #0fc700 !important;
}
.clickable {
  cursor: pointer;
}
</style>
